import { ILocationSuggest, TBoundedBy, TSuggestLocationType } from '@cian/geosuggest-widget/es/types';

import { ISuggestItemDataClassSchema } from '../../repositories/geo-suggest/entities/entities/SuggestItemDataClassSchema';

export const mapRoads = (undergrounds: ISuggestItemDataClassSchema[]): ILocationSuggest[] => {
  return undergrounds.map(road => ({
    regionId: road.regionId as number,
    fullName: road.fullName,
    id: road.id,
    matches: road.matches as TBoundedBy,
    name: road.name,
    type: road.type as unknown as TSuggestLocationType,
  }));
};
